import moment from "moment";
import { useMutation } from "@apollo/react-hooks";
import { MY_LEAVE_EVENTS } from "my-leave/graphql";
import { useOcContractCalendar } from "oc/hooks";

export const useMyLeaveEvents = ({
  roleFilters,
  currentDate,
  viewedByAdmin,
  contract,
  role,
}: {
  roleFilters: any; // Replace 'any' with the actual type if known, e.g., string[] or RoleFilterType[]
  currentDate: Date | string;
  viewedByAdmin?: boolean;
  contract: any; // Replace 'any' with the actual contract type if known
  role: any; // Replace 'any' with the actual role type if known
}) => {
  const { contractCalendar } = useOcContractCalendar({
    contract: contract,
    startDate: moment(currentDate).startOf("month").toDate().toISOString(),
    endDate: moment(currentDate).endOf("month").toDate().toISOString(),
  });

  const [loadEvents, { data, loading, error }] = useMutation(MY_LEAVE_EVENTS, {
    fetchPolicy: "network-only",
    variables: {
      roleFilters,
      currentDate: new Date(currentDate),
      viewedByAdmin: viewedByAdmin ? viewedByAdmin : false,
      role,
    },
  });

  if (error) {
    console.log({
      component: "useLeaveEvents",
      errorDescription:
        "Error occured when fetch data with MY_LEAVE_GET_EVENTS query",
      error: error,
    });
  }

  const events = data?.leaveEvents || [];

  const parseDayType = (dayType: string) => {
    switch (dayType) {
      case ".":
        return "WORKDAY";
      case "P":
        return "REST_DAY";
      case "F":
        return "PAID_HOLLIDAY";
      default:
        return "OTHER_DAY_TYPE";
    }
  };

  let daysArray = contractCalendar?.split("") || [];

  const eventsByDays: any[] = [];

  daysArray.forEach((item: string, index: number) => {
    const date = moment(currentDate).startOf("month").add(index, "days");
    let newItem = {
      date: date.toDate(),
      dayType: parseDayType(item),
    };

    const filteredEvents = events.filter((filterItem: any) => {
      if (
        date.format("YYYY-MM-DD") >=
          moment(filterItem.start).format("YYYY-MM-DD") &&
        date.format("YYYY-MM-DD") <= moment(filterItem.end).format("YYYY-MM-DD")
      )
        return true;
      return false;
    });

    filteredEvents.forEach((item: any) => {
      const returningItem = { ...newItem, ...item };
      eventsByDays.push(returningItem);
      return returningItem;
    });

    return item;
  });

  let result = {
    data: events,
    eventsByDays: eventsByDays,
    loading: loading,
    error: error,
    loadEvents,
  };

  return result;
};

export default useMyLeaveEvents;
